import React from 'react';
import { shape, string, func } from 'prop-types';
import Helmet from 'react-helmet';
import 'typeface-dosis';
import Hamburger from '../components/hamburger';
import '../styles/layout.styl';
import style from '../styles/frameBars.module.styl';
import favicon from '../assets/favicon.png';

class Layout extends React.Component {
  static propTypes = {
    children: func,
    data: shape({
      site: shape({
        siteMetadata: shape({
          title: string.isRequired,
        }),
      }),
    }),
  };

  hamburgerRef = component => {
    this.hamburger = component;
  };

  setFullPageRef = ref => {
    this.hamburger.setFullPageRef(ref);
  };

  render = () => {
    const { children } = this.props;
    return (
      <div>
        <Helmet
          title="GradeIdeas"
          meta={[
            {
              name: 'description',
              content:
                'Interactive Decision Aid (iDeAs) is a tools designed to facilitate shared decision making and patient participation in health care decisions.',
            },
            {
              name: 'keywords',
              content:
                'gradeideas, ideas, decision aid, healthcare, decision aids, decisionaids, grade idea, gradeidea, grade ideas, idea, decisionaid, decision, decisions',
            },
          ]}
          link={[{ rel: 'shortcut icon', type: 'image/png', href: favicon }]}
        />
        <div className={style.frameBarBottom} />
        <div className={style.frameBarBottomZ} />
        <div className={style.frameBarTop} />
        <div className={style.frameBarLeft} />
        <div className={style.frameBarRight} />

        <Hamburger ref={this.hamburgerRef} />
        {children({ ...this.props, setFullPageRef: this.setFullPageRef })}
      </div>
    );
  };
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js